import { Directive, ElementRef, Input, NgModule } from '@angular/core';
import { ProfileService } from '../services';

@Directive({
  selector: '[dependentColor]'
})
export class DependentColorDirective {
  @Input() set dependentColor(person: string) {
    const color = this.colorMap.get(person);
    this.el.nativeElement.classList.add('ab-' + (color || 'green'));
  }

  private colorMap = new Map();

  constructor(private el: ElementRef, private profile: ProfileService) {
    const { dependents, id } = this.profile.getValue();

    const colors = ['green', 'blue', 'red', 'yellow', 'bluegrey'];
    this.colorMap.set(id, colors.shift());
    dependents?.forEach(dep => this.colorMap.set(dep.id, colors.shift()));
  }
}

@NgModule({
  declarations: [DependentColorDirective],
  exports: [DependentColorDirective]
})
export class DependentColorDirectiveModule {}
